import React from 'react';
import { AppBar, Box, Toolbar, useTheme, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setMode } from 'state/global/globalSlice';
import { SiteLogo } from 'components/SiteLogo';
import { ThemeModeToggle } from 'components/ThemeModeToggle/ThemeModeToggle';
import { RootState } from 'state/store';

interface GenericHeaderProps {
  showThemeToggle?: boolean;
}

export const GenericHeader: React.FC<GenericHeaderProps> = ({ showThemeToggle = true }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width: 600px)');
  const themePreference = useSelector((state: RootState) => state.global.mode);

  return (
    <AppBar 
      sx={{
        position: 'sticky',
        background: theme.palette.background.default,
        boxShadow: 'none',
        width: '100%',
        top: 0,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Toolbar 
        sx={{
          justifyContent: 'space-between',
          px: { xs: 2, sm: 3 },
          py: 1,
        }}
      >
        {/* Logo Section */}
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: isMobile ? 'center' : 'flex-start',
            flex: 1,
          }}
        >
          <Box
            component="a"
            href="https://www.campaignking.ai"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: 'none',
              color: 'inherit',
              display: 'flex',
              alignItems: 'center',
              transition: 'opacity 0.3s ease',
              '&:hover': {
                opacity: 0.8,
              },
            }}
          >
            <SiteLogo varient="small" />
          </Box>
        </Box>

        {/* Theme Toggle Section */}
        {showThemeToggle && (
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <ThemeModeToggle
              preference={themePreference}
              onCycle={() => dispatch(setMode())}
            />
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}; 